export default __webpack_public_path__ + "fdf1555b351dda74ec92187ed8f9b574.png";